/* import __COLOCATED_TEMPLATE__ from './label.hbs'; */
/**

 ## Attribute Label

 The `sq-card/attributes-list/attribute/label` block component is designed to be used as a contextual component in: [sq-card/attributes-list/attribute](/components/glass/sq-card/attributes-list/attribute.html).

 **/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'dt',
  classNames: ['card__attributes-list__attribute__label'],
  attributeBindings: ['data-test-card-attribute-label'],
  'data-test-card-attribute-label': true
});